module.exports = __webpack_public_path__ + "r-v3/img/sticker_3.23ae5813.svg";